import { hyperdbHandlers } from 'hyperdb-utils';

export default hyperdbHandlers({ namespace: 'CUSTOMER' });



// WEBPACK FOOTER //
// ./src/frontend/admin/customer/handlers.js